import { DocumentStatusBadge, StockTransferSourceTypeBadge } from '#/modules/commonComponents/badge';
import { formatDateOrDash } from '#/utils/date';

/** Block A：僅狀態 */
export const stockTransferSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          <DocumentStatusBadge status={row?.status} size="default" />
        </div>
      ),
    },
  ],
};

/** Block C+：其餘欄位 */
export const stockTransferSideMsgDetailBlock = {
  fields: [
    { key: 'transferNo', label: '轉倉單號', value: 'transferNo' },
    {
      key: 'transferDate',
      label: '轉倉日',
      value: (row) => formatDateOrDash(row?.transferDate),
    },
    {
      key: 'toWarehouse',
      label: '轉倉倉別',
      value: (row) => {
        const warehouse = row?.toWarehouse;
        if (!warehouse) {
          return '-';
        }
        return [warehouse.code, warehouse.name].filter(Boolean).join(' ') || '-';
      },
    },
    {
      key: 'sourceType',
      label: '來源',
      render: (row) => (
        <div className="side_msg-row">
          <h3>來源</h3>
          <StockTransferSourceTypeBadge sourceType={row?.sourceType} size="default" />
        </div>
      ),
    },
    {
      key: 'lineCount',
      label: '項目數',
      value: (row) => {
        if (Array.isArray(row?.lines)) {
          return row.lines.length;
        }
        if (row?.lineCount != null && row.lineCount !== '') {
          return row.lineCount;
        }
        return '—';
      },
    },
    { key: 'remark', label: '備註', value: 'remark' },
  ],
};

export const stockTransferSideMsgBlocks = [
  stockTransferSideMsgStatusBlock,
  stockTransferSideMsgDetailBlock,
];
